import { GET_FIRMA_STATUS } from '../../constants/ActionTypes'
import { fetchData } from '../Buy'

export const getFirmaStatus = (dispatch, getState) => {
  const idOrdine = getState().ordine.id_ordine

  return dispatch(
    fetchData(GET_FIRMA_STATUS)({
      method: 'GET',
      uri: `${window.brumbrum.url_api}/firma/t/v1/ordine/${idOrdine}/status`,
      callback: GET_FIRMA_STATUS,
      errorMessage: GET_FIRMA_STATUS,
      suppressErrorNotice: true, // l'endpoint da 404 se non c'e' niente da firmare
    })
  )
}
